import React, { useEffect, useState } from "react";
import { Clock, AlertTriangle } from "lucide-react";

/**
 * SLA countdown / breach badge. Pass the ticket-derived sla_due_at (ISO) +
 * sla_breached + status. Re-renders every 30s to keep the countdown fresh.
 */
const fmt = (sec) => {
    if (sec == null) return "—";
    const abs = Math.abs(sec);
    const h = Math.floor(abs / 3600);
    const m = Math.floor((abs % 3600) / 60);
    if (h >= 24) return `${Math.floor(h / 24)}d ${h % 24}h`;
    if (h >= 1) return `${h}h ${m}m`;
    return `${m}m`;
};

const SLATimer = ({ slaDueAt, slaBreached, status }) => {
    const [, setTick] = useState(0);
    useEffect(() => {
        if (!slaDueAt || ["resolved", "closed"].includes(status)) return;
        const t = setInterval(() => setTick((x) => x + 1), 30_000);
        return () => clearInterval(t);
    }, [slaDueAt, status]);

    if (["resolved", "closed"].includes(status)) {
        return <span className="text-[10px] text-zinc-400">—</span>;
    }
    if (!slaDueAt) return <span className="text-[10px] text-zinc-400">—</span>;

    const due = new Date(slaDueAt).getTime();
    const now = Date.now();
    const diff = Math.round((due - now) / 1000);

    if (slaBreached || diff < 0) {
        return (
            <span
                className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2 py-0.5 text-[10px] font-semibold text-rose-700 ring-1 ring-rose-200"
                data-testid="sla-breached-badge"
            >
                <AlertTriangle className="h-3 w-3" /> SLA −{fmt(-diff)}
            </span>
        );
    }
    // < 25% of remaining = warning
    return (
        <span
            className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-medium text-emerald-700 ring-1 ring-emerald-200"
            data-testid="sla-timer-badge"
        >
            <Clock className="h-3 w-3" /> SLA {fmt(diff)}
        </span>
    );
};

export default SLATimer;
